// extracted by mini-css-extract-plugin
export default {"contentInnerContainer":"tenant-edit_contentInnerContainer__Mr5C9","item":"tenant-edit_item__OteTY"};